import useQueryState from "./useQueryState";
import { getYearRangeService } from "../services/timeseries";
import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { useAuthContext } from "./useAuthContext";
import { useUIStore } from "../store/ui";
import { buildIndicatorName, toIndicatorName } from "../helpers/indicatorName";

const accessToken = () => Cookies.get("accessToken");

const useYearRange = () => {
  const isDetrended = useUIStore((s) => s.isDetrended);
  const isLandCoverMasked = useUIStore((s) => s.isLandCoverMasked);
  const {
    queryState: { country, aggregationLevel, layers },
  } = useQueryState();
  const { parsedToken } = useAuthContext();
  const { email: userEmail } = parsedToken || {};
  const isSystemType =
    aggregationLevel === "0" ||
    aggregationLevel === "1" ||
    aggregationLevel === "2";
  const generateIndicatorJson = () => {
    const indicatorPayload: any = [];

    layers
      .filter((layer) => layer.active)
      .forEach((layer) => {
        if (toIndicatorName(layer.displayName) === "hybrid-index") {
          layer.parameters?.forEach((parameter) => {
            indicatorPayload.push({
              indicator: buildIndicatorName(parameter.name, {
                isLandCoverMasked,
                isDetrended,
              }),
              StartMonth: Number(layer.months[0]),
              EndMonth: Number(layer.months[1]),
              StartDekad: Number(layer.dekads[0]),
              EndDekad: Number(layer.dekads[0]),
            });
          });
        } else {
          indicatorPayload.push({
            indicator: buildIndicatorName(layer.displayName, {
              isLandCoverMasked,
              isDetrended,
            }),
            StartMonth: Number(layer.months[0]),
            EndMonth: Number(layer.months[1]),
            StartDekad: Number(layer.dekads[0]),
            EndDekad: Number(layer.dekads[0]),
          });
        }
      });

    return JSON.stringify(indicatorPayload);
  };

  const getYearRange = useQuery(
    [
      "yearRange",
      country,
      layers.filter((layer) => layer.active),
      aggregationLevel,
      isSystemType ? "system" : "user",
      accessToken() ? userEmail : "",
      isDetrended,
      isLandCoverMasked,
    ],
    async () => {
      return await getYearRangeService({
        country,
        adminLevel: aggregationLevel,
        type: isSystemType ? "system" : "user",
        indicatorsJson: generateIndicatorJson(),
      });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
      enabled: layers.filter((layer) => layer.active).length > 0,
    },
  );

  return {
    getYearRange,
  };
};

export default useYearRange;
